import React from 'react';
import { PageIntro } from '../components/PageIntro';
import { PersonRow } from '../components/PersonRow';
import { ContactBand } from '../components/ContactBand';
import { management, advisors } from '../data/people';
export function People() {
  return <>
      <PageIntro eyebrow="People" title="A small group with unusually deep range." lead="Psychology, cognitive neuroscience, linguistics, machine learning, bioinformatics, and operations research — assembled around one interest: software that learns, reasons, and decides." data-id="element-206" data-mp="2dt7bed4zkkbp" />

      <section className="mx-auto max-w-6xl px-6 py-20 lg:px-10" aria-labelledby="management" data-id="element-207" data-mp="2wljn3qhj4xyi">
        <div className="flex items-baseline justify-between border-b border-ink-950 pb-4" data-id="element-208" data-mp="2wjp2kda677uy">
          <h2 id="management" className="font-display text-[26px] text-ink-950" data-id="element-209" data-mp="31ia20ahllnic">
            Management
          </h2>
          <span className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-210" data-mp="176bs06bgsnle">
            {management.length} people
          </span>
        </div>
        <div data-id="element-211" data-mp="24zjbwvc235tb">
          {management.map(person => <PersonRow key={person.name} person={person} data-id="element-212" data-mp="208b3o2mgpqhq" />)}
        </div>

        <div className="mt-20 flex items-baseline justify-between border-b border-ink-950 pb-4" data-id="element-213" data-mp="1v8y72q5sh51y">
          <h2 id="advisors" className="font-display text-[26px] text-ink-950" data-id="element-214" data-mp="1q9vdc1v9el9a">
            Strategic advisors
          </h2>
          <span className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-215" data-mp="2ny5debbhiyxr">
            {advisors.length} {advisors.length === 1 ? 'person' : 'people'}
          </span>
        </div>
        <div data-id="element-216" data-mp="2dz66oyaa5dde">
          {advisors.map(person => <PersonRow key={person.name} person={person} data-id="element-217" data-mp="2dxmo3115iq8g" />)}
        </div>
      </section>

      <ContactBand heading="Work directly with the people listed on this page." body="Engagements are staffed by principals, not handed down. The person who scopes your problem is the person who works on it." data-id="element-218" data-mp="29xkwjkp4rd6w" />
    </>;
}